import { AccountState } from "core/auth/auth.entity";
import styles from "../../orderDetails/OrderDetails.module.scss";
import { strings } from "intl/fa";
import { useAppDispatch, useAppSelector } from "utils/store";
import Wrapper from "components/commons/wrapper/Wrapper";
import Header, { NavType } from "components/commons/header/Header";
import { NavigationActions, AppPage } from "core/navigation/navigation.slice";
import { Row } from "../../orderDetails/DetailCard";
import Footer from "components/commons/footer/Footer";
import { Button, ButtonSize } from "@bale/ui";
import { docsStateLabels, rejectionReasonsErrors } from "utils/auth";

const getIcon = (state: AccountState) => {
  const base = "/icons/adState/";
  switch (state) {
    case AccountState.AwaitingVerification:
      return base + "wait_to_approve.svg";
    case AccountState.DocsRejected:
      return base + "rejected.svg";
  }
};

export const AuthRequestDetail: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const myPanel = useAppSelector((state) => state.auth.myPanel);
  const dispatch = useAppDispatch();

  const onClose = () => {
    dispatch(NavigationActions.setAppPage(AppPage.OrdersList));
  };

  const handleEdit = () => {
    dispatch(NavigationActions.setAppPage(AppPage.Invoicing));
  };

  const rejectionErrorIds = myPanel.reason.split(",");

  let rejectionTexts: string[] = [];
  rejectionErrorIds.forEach((errorId) =>
    rejectionTexts.push(
      rejectionReasonsErrors[errorId as keyof typeof rejectionReasonsErrors]
    )
  );

  return (
    <Wrapper>
      <Header
        onClose={onClose}
        navType={NavType.both}
        title={strings.invoicing.request_details}
      />
      <div className={styles.Container}>
        <div className={styles.Card}>
          <div className={styles.HeaderWrapper}>
            <div className={styles.LabelWrapper}>
              <img src={getIcon(myPanel.state)} alt="" />
              <p className={styles.Label}>
                {docsStateLabels(myPanel.state).label}
              </p>
            </div>
          </div>
          <div className={styles.InfoWrapper}>
            <Row
              rowKey={strings.invoicing.organization_name}
              value={myPanel.full_name}
            />
            <Row
              rowKey={strings.invoicing.phone_number}
              value={myPanel.land_line_phone}
            />
            <Row
              rowKey={strings.invoicing.postal_code}
              value={myPanel.zip_code}
            />
            <Row
              rowKey={strings.invoicing.national_id}
              value={myPanel.shenase_melli}
            />
            <Row
              rowKey={strings.invoicing.commercial_number}
              value={myPanel.economic_number}
            />
            {myPanel.state === AccountState.DocsRejected && (
              <div className={styles.rejectionReason}>
                <div style={{ marginBottom: "15px" }}>
                  {strings.invoicing.rejection_reason}
                </div>
                {rejectionTexts.map((rejText) => (
                  <li key={rejText}>{rejText}</li>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {myPanel.state === AccountState.DocsRejected && (
        <Footer>
          <Button
            onClick={handleEdit}
            text={strings.invoicing.edit_request}
            size={ButtonSize.XLarge}
          />
        </Footer>
      )}
    </Wrapper>
  );
};
